function loadScriptAsync(src) {
  // eslint-disable-next-line no-unused-vars
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = false;
    script.onload = () => resolve(script);
    document.body.append(script);
  });
}

export default loadScriptAsync;
